import templateUrl from 'emun.customer/customer-activities.htm'
import AutoQuery from 'servicestack/auto-query/auto-query'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import activityConfig from 'emun.activity/activity.config'

class CustomerActivitiesController {
	constructor($rootScope) {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.activityConfig = activityConfig;
		if (this.customer) {
			this.activities = new AutoQuery({
				url: 'QueryActivities.json?retailerId=' + this.customer.id,
				orderBy: '-StartDate',
				autoLoad: true,
				pageSize: 10
			})
		} else if (this.prospect) {
			this.activities = new AutoQuery({
				url: 'QueryActivities.json?prospectId=' + this.prospect.id,
				orderBy: '-StartDate',
				autoLoad: true,
				pageSize: 10
			});
		} else {
			this.activities = new AutoQuery({
				url: 'QueryProspectActivities.json',
				orderBy: '-StartDate',
				autoLoad: true,
				pageSize: 10
			});
		}
		$rootScope.$on('activitySaved', () => $ctrl.activities.load(true));
		$rootScope.$on('activityDeleted', () => $ctrl.activities.load(true));
	}
}

let CustomerActivities = {
	bindings: {
		customer: '<',
		prospect: '<',
		prospectMode: '<'
	},
	controller: CustomerActivitiesController,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl
	}
}

export default CustomerActivities